import axios from 'axios'

const firebaseConfigApi = {
  url: `${process.env.FIREBASE_URL}`,
  json: `.json?print=pretty`
}

export default async function ChatData() {
  try {
    const { data } = await axios.get(
      `${firebaseConfigApi.url}/DadosSite/SiteConteudo/Chat${firebaseConfigApi.json}`
    )

    return data
  } catch (err) {
    console.error(err)
  }
}
